{
  "name": "Bomb Button",
  "powerupName": "CoconutBomb",
  "levelUpDescriptions": [
    "BombUpgradeDescription1",
    "BombUpgradeDescription2",
    "BombUpgradeDescription3",
    "BombUpgradeDescription4",
    "BombUpgradeDescription5"
  ]
}